import React from 'react';
import { ArrowRight } from 'lucide-react';
import Button from '@/components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-orcsys-500 to-orcsys-600 py-20 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMS41IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1vcGFjaXR5PSIwLjEiPjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjE1Ii8+PHBhdGggZD0iTTMwIDE1TDQ1IDMwIDMwIDQ1IDE1IDMweiIvPjwvZz48L3N2Zz4=')] opacity-30" />
      
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-white mb-6">
          Prêt à Démarrer Votre Projet ?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Parlons de votre vision et découvrons comment nous pouvons vous aider à la concrétiser.
        </p>
        <Button.Link 
          href="#book" 
          variant="outline" 
          size="lg"
          className="bg-white text-orcsys-500 border-white hover:bg-white/90 hover:text-orcsys-600"
        >
          Planifier un appel
          <ArrowRight className="ml-2 w-5 h-5" />
        </Button.Link>
      </div>
    </section>
  );
};

export default CTASection; 